/**
 * The colours somebody chose at their first run, kept so the rest of the
 * product can use the same room.
 *
 * The daily check-in is the first place this matters: opening the app every
 * morning to a palette you picked yourself is the difference between a theme
 * and a decoration. Stored per user in localStorage for an instant read — the
 * check-in paints before any request could land — and rebuilt from the saved
 * learning profile whenever the local copy is missing, so it survives a new
 * browser or a cleared cache.
 */
import { paletteFromInterests } from './journey.logic';

const KEY = (userId: number | string) => `mmai.journeyPalette.v1.${userId}`;

export function savePalette(userId: number | string | undefined, palette: string[]): void {
  if (userId === undefined || !palette.length) return;
  try {
    localStorage.setItem(KEY(userId), JSON.stringify(palette));
  } catch {
    // A private window or a full quota is not worth breaking onboarding over.
  }
}

/** The stored palette, or null when there is nothing usable. */
export function readPalette(userId: number | string | undefined): string[] | null {
  if (userId === undefined) return null;
  try {
    const raw = localStorage.getItem(KEY(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    const colors = parsed.filter((c) => typeof c === 'string' && /^#[0-9a-f]{6}$/i.test(c));
    return colors.length ? colors : null;
  } catch {
    return null;
  }
}

/** Rebuild it from whatever interests are on file. */
export const paletteForInterests = paletteFromInterests;
